module.exports = __webpack_public_path__ + "cd455783/img/placeholder.888fcd0b.svg";